import { Text } from "../../../components/common";
import { PauseIcon, PlayIcon } from "../../../components/icons";
import React from "react";
import { secondsToMinutes } from "@repo-sapiens/helpers";

type Props = {
  title: string;
  duration: number;
  playing?: boolean;
  onClick?: () => void;
};

export const ChapterItem: React.FC<Props> = ({
  title,
  duration,
  playing,
  onClick,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 20px 10px 0px",
        borderBottom: "1px solid #2E2D33",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <div>
        <Text.Body style={{ margin: 0 }}>{title}</Text.Body>
        <p style={{ margin: 0, fontSize: "11px", color: "#77777A" }}>
          {secondsToMinutes(duration)}
        </p>
      </div>
      {playing ? (
        <PauseIcon
          fill="#6A53FE"
          style={{ width: "28px", height: "28px" }}
          onClick={onClick}
        />
      ) : (
        <PlayIcon
          fill="#6A53FE"
          style={{ width: "28px", height: "28px" }}
          onClick={onClick}
        />
      )}
    </div>
  );
};
